<template>
    <div class="header">
        <img src="../assets/badge_trans.png" style="margin-right:5px; float:left;"/>
        <div style="height:94px;padding-top:28px;">Mecklenburg County Sheriff's Office</div>
    </div>
</template>

<script>
    export default {
        name:"Header"
    }
</script>

<style scoped>

</style>